/**
 * Utilitários de formatação para exibição visual
 * IMPORTANTE: Estas funções são apenas para apresentação.
 * O banco de dados continua usando valores originais.
 */

/**
 * Formata número de fatura com máscara visual FAT-XXXX
 * @param numero - Número inteiro da fatura (ex: 10)
 * @returns String formatada (ex: "FAT-0010")
 * @example
 * formatInvoiceNumber(1) // "FAT-0001"
 * formatInvoiceNumber(29) // "FAT-0029"
 * formatInvoiceNumber(1234) // "FAT-1234"
 */
export function formatInvoiceNumber(numero: number | string): string {
  const num = typeof numero === 'string' ? parseInt(numero, 10) : numero;
  
  if (isNaN(num)) {
    return 'FAT-0000';
  }
  
  // Formata com 4 dígitos, preenchendo com zeros à esquerda
  const formatted = num.toString().padStart(4, '0');
  return `FAT-${formatted}`;
}

/**
 * Remove a máscara visual de número de fatura e retorna o número inteiro
 * Usado para busca e filtros antes de enviar ao backend
 * @param formatted - String formatada (ex: "FAT-0010" ou "10")
 * @returns Número inteiro (ex: 10)
 * @example
 * parseInvoiceNumber("FAT-0010") // 10
 * parseInvoiceNumber("FAT-1234") // 1234
 * parseInvoiceNumber("10") // 10
 * parseInvoiceNumber("0010") // 10
 */
export function parseInvoiceNumber(formatted: string): number {
  // Remove prefixo "FAT-" se existir
  const cleaned = formatted.replace(/^FAT-/i, '').trim();
  
  // Converte para número (remove zeros à esquerda automaticamente)
  const num = parseInt(cleaned, 10);
  
  return isNaN(num) ? 0 : num;
}

/**
 * Valida se uma string é um número de fatura válido
 * @param value - String a validar
 * @returns true se for válido
 * @example
 * isValidInvoiceNumber("FAT-0010") // true
 * isValidInvoiceNumber("10") // true
 * isValidInvoiceNumber("abc") // false
 */
export function isValidInvoiceNumber(value: string): boolean {
  const cleaned = value.replace(/^FAT-/i, '').trim();
  const num = parseInt(cleaned, 10);
  return !isNaN(num) && num > 0;
}
